import { useState, useMemo, useEffect, useRef, useCallback } from 'react';
import { useOnboardingStore } from '../../store/useOnboardingStore';
import { Link } from 'react-router-dom';
import logo from "../../assets/images/logo_2.png";
import React from 'react';

/* ═══════════════════════════════════════════════════
   INJECT STYLES
═══════════════════════════════════════════════════ */
const injectKF = () => {
  if (document.getElementById("ob3-kf")) return;
  const s = document.createElement("style");
  s.id = "ob3-kf";
  s.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    @keyframes slideInBot3 { from{opacity:0;transform:translateY(-8px) scale(0.96)} to{opacity:1;transform:translateY(0) scale(1)} }
    @keyframes botCursor3  { 0%,100%{opacity:1} 50%{opacity:0} }
    @keyframes speakBar3   { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.9)} }
    @keyframes pulseDot3   { 0%,100%{opacity:1} 50%{opacity:.35} }
    @keyframes chipPop     { 0%{transform:scale(1)} 40%{transform:scale(1.08)} 100%{transform:scale(1)} }
    @keyframes slideInUp   { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
    @keyframes ob3-shimmer { 0%{background-position:200% center} 100%{background-position:-200% center} }

    @keyframes botBobSvg3  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-2.5px)} }
    @keyframes floatHeartL1_3 {
      0%  { transform:translate(0,0)         scale(1);    opacity:1; }
      100%{ transform:translate(-14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartL2_3 {
      0%  { transform:translate(0,0)        scale(0.82); opacity:0.9; }
      100%{ transform:translate(-4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartL3_3 {
      0%  { transform:translate(0,0)       scale(0.68); opacity:0.8; }
      100%{ transform:translate(9px,-50px) scale(0.22); opacity:0; }
    }
    @keyframes floatHeartR1_3 {
      0%  { transform:translate(0,0)        scale(1);    opacity:1; }
      100%{ transform:translate(14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartR2_3 {
      0%  { transform:translate(0,0)       scale(0.82); opacity:0.9; }
      100%{ transform:translate(4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartR3_3 {
      0%  { transform:translate(0,0)        scale(0.68); opacity:0.8; }
      100%{ transform:translate(-9px,-50px) scale(0.22); opacity:0; }
    }

    .ob3-bot-bob { animation: botBobSvg3 3s ease-in-out infinite; }
    .ob3-hl1 { animation: floatHeartL1_3 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
    .ob3-hl2 { animation: floatHeartL2_3 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
    .ob3-hl3 { animation: floatHeartL3_3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
    .ob3-hr1 { animation: floatHeartR1_3 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
    .ob3-hr2 { animation: floatHeartR2_3 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
    .ob3-hr3 { animation: floatHeartR3_3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }

    .ob3-wrap { position:fixed; z-index:99999; animation:slideInBot3 .28s cubic-bezier(.34,1.2,.64,1) both; }
    .ob3-wrap::before { content:''; position:absolute; width:16px; height:9px; background:#c0001a; clip-path:polygon(50% 0%,100% 100%,0% 100%); }
    .ob3-wrap.below::before   { top:-9px;    left:24px; }
    .ob3-wrap.above::before   { bottom:-9px; left:24px; transform:rotate(180deg); }
    .ob3-wrap.toright::before { top:24px;    left:-9px; transform:rotate(-90deg); }
    .ob3-wrap.toleft::before  { top:24px;    right:-9px; transform:rotate(90deg); }

    .ob3-popup { background:#fff; border-radius:14px; border:1px solid rgba(0,0,0,.07); overflow:hidden; box-shadow:0 4px 8px rgba(0,0,0,.06),0 18px 52px rgba(0,0,0,.18),0 2px 10px rgba(192,0,26,.1); }
    .ob3-hd { background:linear-gradient(135deg,#c0001a 0%,#8b0000 58%,#5c0000 100%); padding:12px 14px 10px; display:flex; align-items:center; gap:10px; position:relative; overflow:visible; }
    .ob3-hd::after { content:''; position:absolute; inset:0; pointer-events:none; background-image:linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px); background-size:16px 16px; }
    .ob3-av   { position:relative; flex-shrink:0; z-index:1; overflow:visible; }
    .ob3-bars { display:flex; align-items:flex-end; gap:2px; position:absolute; bottom:-3px; right:-4px; background:rgba(0,0,0,.3); border-radius:4px; padding:2px 3px; z-index:2; }
    .ob3-b    { width:2.5px; border-radius:2px; background:#fff; transform-origin:bottom; }
    .ob3-b:nth-child(1){ height:4px;  animation:speakBar3 .48s .00s ease-in-out infinite; }
    .ob3-b:nth-child(2){ height:9px;  animation:speakBar3 .48s .10s ease-in-out infinite; }
    .ob3-b:nth-child(3){ height:6px;  animation:speakBar3 .48s .20s ease-in-out infinite; }
    .ob3-b:nth-child(4){ height:3px;  animation:speakBar3 .48s .30s ease-in-out infinite; }
    .ob3-meta  { flex:1; z-index:1; min-width:0; overflow:hidden; }
    .ob3-name  { font-size:11.5px; font-weight:800; color:#fff; letter-spacing:.06em; font-family:'DM Mono','Fira Code',monospace; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .ob3-sub   { font-size:9.5px; color:rgba(255,255,255,.7); display:flex; align-items:center; gap:4px; margin-top:2px; }
    .ob3-dot   { width:5px; height:5px; border-radius:50%; background:#6effa0; box-shadow:0 0 4px rgba(100,255,150,.85); flex-shrink:0; animation:pulseDot3 2s ease-in-out infinite; }
    .ob3-badge { z-index:1; flex-shrink:0; background:rgba(255,255,255,.16); border:1px solid rgba(255,255,255,.3); border-radius:20px; padding:2px 8px; font-size:10px; font-weight:700; color:#fff; white-space:nowrap; }
    .ob3-tag     { background:linear-gradient(90deg,#fff5f5,#fff); border-bottom:1px solid rgba(192,0,26,.1); padding:5px 14px; display:flex; align-items:center; gap:6px; }
    .ob3-tag-dot { width:5px; height:5px; border-radius:50%; background:#c0001a; flex-shrink:0; }
    .ob3-tag-txt { font-size:9.5px; font-weight:800; color:#c0001a; letter-spacing:.08em; }
    .ob3-body { padding:10px 14px 8px; }
    .ob3-msg  { font-size:13px; line-height:1.62; color:#1a1a1a; word-break:break-word; margin:0; }
    .ob3-msg strong { color:#c0001a; font-weight:800; }
    .ob3-cur  { display:inline-block; width:2px; height:13px; background:#c0001a; border-radius:2px; margin-left:2px; vertical-align:middle; animation:botCursor3 .65s ease-in-out infinite; }
    .ob3-ft   { padding:8px 14px 11px; display:flex; align-items:center; justify-content:space-between; gap:8px; border-top:1px solid rgba(0,0,0,.05); background:#fafafa; }
    .ob3-dots { display:flex; gap:4px; align-items:center; }
    .ob3-d    { width:6px; height:6px; border-radius:50%; background:#e0e0e0; transition:all .3s; }
    .ob3-d.on { width:18px; border-radius:999px; background:linear-gradient(90deg,#c0001a,#8b0000); }
    .ob3-skip { background:none; border:none; cursor:pointer; font-size:11px; color:#c0c0c0; padding:4px 6px; border-radius:6px; transition:all .18s; white-space:nowrap; }
    .ob3-skip:hover { background:#f0f0f0; color:#888; }
    .ob3-next { background:linear-gradient(135deg,#c0001a,#8b0000); color:#fff; border:none; border-radius:8px; padding:7px 16px; font-size:12px; font-weight:800; cursor:pointer; letter-spacing:.03em; box-shadow:0 3px 12px rgba(192,0,26,.32); transition:all .18s; white-space:nowrap; }
    .ob3-next:hover  { transform:translateY(-1px); box-shadow:0 5px 16px rgba(192,0,26,.46); }
    .ob3-next:active { transform:scale(.97); }

    /* ── Page background ── */
    .ob3-section { background:#f8f5f0 !important; min-height:100vh !important; }

    /* ── Progress bars ── */
    .ob3-prog-wrap { display:flex !important; gap:5px !important; margin-top:10px !important; }
    .ob3-prog-bar  { height:4px !important; border-radius:999px !important; flex:1 !important; background:#e2e8f0 !important; }
    .ob3-prog-bar.done   { background:linear-gradient(90deg,#c0001a,#8b0000) !important; }
    .ob3-prog-bar.active { background:linear-gradient(90deg,#e0001f,#c0001a) !important; animation:ob3-shimmer 2s linear infinite !important; background-size:200% auto !important; }

    .ob3-search-wrap  { position:relative; margin-bottom:10px; }
    .ob3-search-icon  { position:absolute; left:11px; top:50%; transform:translateY(-50%); pointer-events:none; }
    .ob3-search-input { width:100%; height:40px; border:1.5px solid #d4cfc8; border-radius:10px; padding:0 14px 0 38px; font-size:13.5px; color:#1a1a1a; background:#fafafa; outline:none; display:block; transition:border-color .15s,box-shadow .15s,background .15s; }
    .ob3-search-input:focus { border-color:#c0001a; box-shadow:0 0 0 3px rgba(192,0,26,.1); background:#fff; }
    .ob3-search-input::placeholder { color:#adb5bd; }

    /* ══════════════════════════════════════════════
       UNIFIED PILL / CHIP — same look everywhere
       Both single-select (.ob3-pill) and multi-select (.ob3-chip)
       share identical base + selected styles.
    ══════════════════════════════════════════════ */

    /* BASE — unselected state */
    .ob3-pill,
    .ob3-chip {
      display:inline-flex !important;
      align-items:center !important;
      gap:5px !important;
      border:1.5px solid #1a2340 !important;   /* same dark navy border as screenshot */
      border-radius:999px !important;
      background:#fff !important;
      color:#1a2340 !important;
      font-size:13px !important;
      font-weight:500 !important;
      padding:7px 18px !important;
      cursor:pointer !important;
      transition:border-color .14s, background .14s, color .14s, box-shadow .14s !important;
      margin:0 6px 8px 0 !important;
      user-select:none !important;
    }
    .ob3-pill:hover,
    .ob3-chip:hover {
      border-color:#c0001a !important;
      color:#c0001a !important;
      background:#fff5f5 !important;
    }

    /* SELECTED state — red outline + red text, white fill (matches screenshot) */
    .ob3-pill.selected,
    .ob3-chip.selected {
      border-color:#c0001a !important;
      background:#fff !important;
      color:#c0001a !important;
      font-weight:600 !important;
      box-shadow:0 0 0 3px rgba(192,0,26,.1) !important;
      animation:chipPop .2s ease-out !important;
    }
    .ob3-pill.selected:hover,
    .ob3-chip.selected:hover {
      background:#fff5f5 !important;
    }

    .ob3-chip-check { font-size:11px; font-weight:900; color:#c0001a; }
    .ob3-chip-count { display:inline-flex; align-items:center; justify-content:center; background:rgba(192,0,26,.1); color:#c0001a; border-radius:999px; font-size:11px; font-weight:700; padding:1px 8px; min-width:20px; margin-left:4px; }
    .ob3-multi-hint { font-size:11.5px; color:#888; margin-bottom:8px; display:flex; align-items:center; gap:5px; flex-wrap:wrap; }
    .ob3-section-label { font-size:11px; font-weight:700; color:#adb5bd; letter-spacing:.07em; text-transform:uppercase; margin:8px 0 6px; }
    .ob3-pills-wrap { display:flex; flex-wrap:wrap; gap:0; animation:slideInUp .2s ease-out; }
    .ob3-occ-selected { display:inline-flex; align-items:center; gap:8px; background:#fff5f5; border:1.5px solid rgba(192,0,26,.3); border-radius:999px; padding:5px 14px; font-size:13px; font-weight:600; color:#c0001a; margin-bottom:10px; animation:slideInUp .2s ease-out; }
    .ob3-occ-clear { background:none; border:none; cursor:pointer; color:#c0001a; font-size:14px; line-height:1; padding:0 2px; opacity:.7; transition:opacity .15s; }
    .ob3-occ-clear:hover { opacity:1; }
    .ob3-use-link { font-size:12.5px; color:#c0001a; background:none; border:none; padding:4px 0; cursor:pointer; text-decoration:underline; display:inline-block; margin-top:4px; }
    .ob3-use-link:hover { color:#8b0000; }
    .ob3-slider-track { position:relative; height:6px; background:#e2e8f0; border-radius:999px; margin:10px 0 6px; }
    .ob3-slider-fill  { position:absolute; left:0; top:0; height:100%; border-radius:999px; background:linear-gradient(90deg,#c0001a,#8b0000); pointer-events:none; }
    input[type=range].ob3-range { position:absolute; top:-5px; left:0; width:100%; height:16px; background:transparent; border:none; outline:none; margin:0; padding:0; cursor:pointer; -webkit-appearance:none; }
    input[type=range].ob3-range::-webkit-slider-thumb { -webkit-appearance:none; width:20px; height:20px; border-radius:50%; background:#fff; border:2.5px solid #c0001a; box-shadow:0 2px 8px rgba(192,0,26,.28); cursor:pointer; transition:box-shadow .15s; }
    input[type=range].ob3-range::-webkit-slider-thumb:hover { box-shadow:0 0 0 6px rgba(192,0,26,.12),0 2px 8px rgba(192,0,26,.28); }
    input[type=range].ob3-range::-moz-range-thumb { width:20px; height:20px; border-radius:50%; background:#fff; border:2.5px solid #c0001a; box-shadow:0 2px 8px rgba(192,0,26,.28); cursor:pointer; }
    .ob3-ht-badge { display:inline-flex; align-items:center; background:#fff5f5; border:1.5px solid rgba(192,0,26,.2); color:#c0001a; border-radius:8px; padding:4px 12px; font-size:13.5px; font-weight:700; }

    /* ── Continue + Back buttons ── */
    .ob3-btn-continue {
      display:inline-flex !important; align-items:center !important; gap:8px !important;
      background:linear-gradient(135deg,#c0001a,#8b0000) !important;
      color:#fff !important; border:none !important; border-radius:10px !important;
      padding:12px 28px !important; font-size:14px !important; font-weight:700 !important;
      font-family:'Inter',sans-serif !important; cursor:pointer !important;
      letter-spacing:.02em !important; box-shadow:0 3px 14px rgba(192,0,26,.35) !important;
      transition:transform .18s,box-shadow .18s !important;
    }
    .ob3-btn-continue:hover  { transform:translateY(-1px) !important; box-shadow:0 5px 20px rgba(192,0,26,.48) !important; }
    .ob3-btn-continue:active { transform:scale(.97) !important; }
    .ob3-btn-continue.lit { background:linear-gradient(135deg,#e0001f,#c0001a) !important; }

    .ob3-btn-back {
      display:inline-flex !important; align-items:center !important; gap:7px !important;
      border:1.5px solid #d0cbc3 !important; background:transparent !important; color:#374151 !important;
      border-radius:10px !important; padding:11px 22px !important;
      font-size:14px !important; font-weight:600 !important;
      font-family:'Inter',sans-serif !important; cursor:pointer !important;
      transition:border-color .15s !important;
    }
    .ob3-btn-back:hover { border-color:#94a3b8 !important; }

    /* ── Mobile: compact, exact-anchor-aligned, overlap-safe bot popup ── */
    @media (max-width: 767px) {
      .ob3-wrap    { max-width:calc(100vw - 24px); }
      .ob3-popup   { border-radius:10px; }
      .ob3-hd      { padding:7px 8px 6px; gap:6px; }
      .ob3-av svg  { width:34px !important; height:34px !important; }
      .ob3-bars    { padding:1px 2px; bottom:-2px; right:-2px; }
      .ob3-b       { width:1.5px; }
      .ob3-name    { font-size:9px; letter-spacing:.03em; }
      .ob3-sub     { font-size:7.5px; }
      .ob3-dot     { width:4px; height:4px; }
      .ob3-badge   { font-size:8px; padding:1px 5px; }
      .ob3-tag     { padding:3px 8px; }
      .ob3-tag-dot { width:4px; height:4px; }
      .ob3-tag-txt { font-size:7.5px; }
      .ob3-body    { padding:6px 8px 5px; }
      .ob3-msg     { font-size:11px; line-height:1.4; }
      .ob3-ft      { padding:5px 8px 7px; }
      .ob3-skip    { font-size:9px; padding:2px 4px; }
      .ob3-next    { font-size:10px; padding:5px 10px; }
      .ob3-d       { width:4px; height:4px; }
      .ob3-d.on    { width:12px; }
    }
  `;
  document.head.appendChild(s);
};

/* ═══════════════════════════════════════════════════
   BOT FACE SVG
═══════════════════════════════════════════════════ */
const BotFaceSVG: React.FC = () => (
  <svg width="64" height="64" viewBox="0 0 72 72" fill="none" style={{ overflow: "visible" }}>
    <defs>
      <style>{`
        .ob3-bot-bob { animation: botBobSvg3 3s ease-in-out infinite; }
        .ob3-hl1 { animation: floatHeartL1_3 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
        .ob3-hl2 { animation: floatHeartL2_3 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
        .ob3-hl3 { animation: floatHeartL3_3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
        .ob3-hr1 { animation: floatHeartR1_3 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
        .ob3-hr2 { animation: floatHeartR2_3 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
        .ob3-hr3 { animation: floatHeartR3_3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }
      `}</style>
    </defs>
    <g className="ob3-bot-bob">
      <line x1="36" y1="10" x2="36" y2="3" stroke="rgba(255,255,255,0.82)" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="36" cy="2" r="3.2" fill="rgba(255,255,255,0.9)" />
      <rect x="7" y="10" width="58" height="46" rx="15" fill="rgba(255,255,255,0.97)" />
      <circle cx="7"  cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <circle cx="65" cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <rect x="11" y="17" width="24" height="20" rx="9" fill="#c0001a" />
      <rect x="37" y="17" width="24" height="20" rx="9" fill="#8b0000" />
      <ellipse cx="23" cy="27" rx="9" ry="8" fill="white" />
      <ellipse cx="49" cy="27" rx="9" ry="8" fill="white" />
      <g className="ob3-hl1"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff3d6b" /></g>
      <g className="ob3-hl2"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob3-hl3"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff7099" /></g>
      <g className="ob3-hr1"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff3d6b" /></g>
      <g className="ob3-hr2"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob3-hr3"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff7099" /></g>
      <path d="M16,46 Q36,60 56,46" stroke="#c0001a" strokeWidth="2.8" strokeLinecap="round" fill="none" />
      <ellipse cx="12" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <ellipse cx="60" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <line x1="7"  y1="28" x2="2"  y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="7"  y1="36" x2="2"  y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="28" x2="70" y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="36" x2="70" y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
    </g>
  </svg>
);

/* ═══════════════════════════════════════════════════
   TYPES
═══════════════════════════════════════════════════ */
type BotSide = "below" | "above" | "toright" | "toleft";
interface StepData { tag:string; plain:string; html:React.ReactNode; sideLg:BotSide; }

// Shared sizing constants — used by BotPopup for its own box AND by Step3
// to size the spacer that pushes page content down so the popup never
// overlaps the next form field/MCQ. Kept small so the bot stays compact
// and hugs the exact anchor field on mobile.
const GAP = 8;
const POPUP_W_MOBILE = 230, POPUP_W_DESKTOP = 310;
const POPUP_H_MOBILE = 130, POPUP_H_DESKTOP = 240;

/* ═══════════════════════════════════════════════════
   BOT POPUP
═══════════════════════════════════════════════════ */
interface PopupProps {
  anchorRef: React.RefObject<HTMLDivElement | null>;
  step: number; total: number; data: StepData;
  onSkip:()=>void; onNext:()=>void; nextLabel:string;
}

const BotPopup: React.FC<PopupProps> = ({ anchorRef, step, total, data, onSkip, onNext, nextLabel }) => {
  // Mobile gets a smaller card so it never overlaps form fields or screen edges.
  const isMobileScreen = typeof window !== "undefined" && window.innerWidth < 768;
  const PW = isMobileScreen ? POPUP_W_MOBILE : POPUP_W_DESKTOP;
  const POPUP_H = isMobileScreen ? POPUP_H_MOBILE : POPUP_H_DESKTOP;

  const [pos,        setPos]        = useState<{top:number;left:number;width:number}|null>(null);
  const [activeSide, setActiveSide] = useState<BotSide>("below");
  const [displayed,  setDisplayed]  = useState("");
  const [done,       setDone]       = useState(false);
  const [status,     setStatus]     = useState("typing...");
  const timerRef = useRef<ReturnType<typeof setTimeout>|null>(null);
  const retryRef = useRef<ReturnType<typeof setTimeout>|null>(null);

  const calcPos = useCallback((): boolean => {
    if (!anchorRef.current) return false;
    const r = anchorRef.current.getBoundingClientRect();
    const vw = window.innerWidth, vh = window.innerHeight;
    if (r.width === 0 && r.height === 0) return false;

    // Popup always appears BELOW the anchor — never above, never to the side.
    // It hugs the anchor's own left edge (not screen-center) so it visually
    // sits directly under the field it refers to.
    if (vw < 768) {
      const popW = Math.min(vw - 16, PW);
      const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));
      let left = r.left;
      left = Math.max(8, Math.min(left, vw - popW - 8));
      setActiveSide("below");
      setPos({ top, left, width: popW });
      return true;
    }

    let left = r.left;
    if (left + PW > vw - 8) left = vw - PW - 8;
    left = Math.max(12, Math.min(left, vw - PW - 12));

    const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));

    setActiveSide("below");
    setPos({ top, left, width: PW });
    return true;
  }, [anchorRef]);

  useEffect(() => {
    let attempts = 0; const MAX = 50;
    if (retryRef.current) clearTimeout(retryRef.current);
    setPos(null);
    const tryCalc = () => { const ok = calcPos(); if (!ok && attempts < MAX) { attempts++; retryRef.current = setTimeout(tryCalc, 80); } };
    tryCalc();
    window.addEventListener("resize", calcPos);
    window.addEventListener("scroll", calcPos, true);
    return () => { if (retryRef.current) clearTimeout(retryRef.current); window.removeEventListener("resize", calcPos); window.removeEventListener("scroll", calcPos, true); };
  }, [calcPos, step]);

  useEffect(() => {
    setDisplayed(""); setDone(false); setStatus("typing...");
    let i = 0;
    const tick = () => { if (i <= data.plain.length) { setDisplayed(data.plain.slice(0,i)); i++; timerRef.current = setTimeout(tick,21); } else { setDone(true); setStatus("Online — here to guide you!"); } };
    tick();
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [data.plain, step]);

  if (!pos) return null;
  const isSide = activeSide === "toright" || activeSide === "toleft";

  return (
    <div className={`ob3-wrap ${activeSide}`} style={{ top:pos.top, left:pos.left, width:pos.width, transform:isSide?"translateY(-50%)":"none" }}>
      <div className="ob3-popup" style={{ width:"100%" }}>
        <div className="ob3-hd">
          <div className="ob3-av">
            <BotFaceSVG />
            <div className="ob3-bars"><div className="ob3-b"/><div className="ob3-b"/><div className="ob3-b"/><div className="ob3-b"/></div>
          </div>
          <div className="ob3-meta">
            <div className="ob3-name">SLAMMMM GUIDE</div>
            <div className="ob3-sub"><div className="ob3-dot"/><span>{status}</span></div>
          </div>
          <div className="ob3-badge">{step}/{total}</div>
        </div>
        <div className="ob3-tag"><div className="ob3-tag-dot"/><div className="ob3-tag-txt">{data.tag}</div></div>
        <div className="ob3-body">
          {done ? <p className="ob3-msg">{data.html}</p> : <p className="ob3-msg">{displayed}<span className="ob3-cur"/></p>}
        </div>
        <div className="ob3-ft">
          <div className="ob3-dots">{Array.from({length:total}).map((_,i)=><div key={i} className={`ob3-d${i+1===step?" on":""}`}/>)}</div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <button className="ob3-skip" onClick={onSkip}>Skip guide</button>
            <button className="ob3-next" onClick={onNext}
              onMouseEnter={e=>{(e.currentTarget as HTMLButtonElement).style.transform="translateY(-1px)";}}
              onMouseLeave={e=>{(e.currentTarget as HTMLButtonElement).style.transform="none";}}
            >{nextLabel}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ── Search icon ── */
const SearchIcon = () => (
  <svg className="ob3-search-icon" width="14" height="14" fill="none" stroke="#94a3b8" strokeWidth="2" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
  </svg>
);

const POPULAR_OCCUPATIONS = [
  "Student","Engineer","Doctor","Teacher","Business Owner",
  "Entrepreneur","Software Engineer","Nurse","Designer","Manager",
  "Lawyer","Accountant","Artist","Chef","Freelancer",
];

const ALL_OCCUPATIONS = [
  "Accountant","Actor","Architect","Artist","Author","Baker","Banker","Barber","Biologist","Business Owner",
  "Carpenter","Chef","Civil Engineer","Consultant","Content Creator","Cook","Customer Service",
  "Data Scientist","Dentist","Designer","Doctor","Driver","Electrician","Engineer",
  "Entrepreneur","Executive","Fashion Designer","Filmmaker","Financial Analyst","Firefighter","Fitness Trainer",
  "Freelancer","Full Stack Developer","Graphic Designer","HR Manager","Interior Designer","IT Specialist",
  "Journalist","Lawyer","Librarian","Manager","Marketing Manager","Mechanic","Model","Musician","Nurse",
  "Nutritionist","Painter","Pharmacist","Photographer","Physiotherapist","Pilot",
  "Plumber","Police Officer","Professor","Programmer","Project Manager","Psychologist","Real Estate Agent",
  "Receptionist","Researcher","Sales Executive","Scientist","Security Guard","Self Employed","Social Worker",
  "Software Engineer","Student","Surgeon","Teacher","Technician","UI/UX Designer","UX Researcher",
  "Veterinary","Videographer","Web Developer","Writer","Yoga Instructor","Other",
].sort();

/* ═══════════════════════════════════════════════════
   STEP 3 — MAIN COMPONENT
═══════════════════════════════════════════════════ */
const Step3 = () => {
  const {
    questions, selectOption, inputs, handleInputChange, currentStep,
    validate3, errors, nextStep, prevStep, optionSearchTerms, setOptionSearchTerm,
  } = useOnboardingStore();

  const [btnHighlight, setBtnHighlight] = useState(false);
  const [occSearch,    setOccSearch]    = useState("");
  const [persnSearch,  setPersnSearch]  = useState<Record<number,string>>({});

  const stepQuestions = useMemo(
    () => (questions||[]).filter((q:any) => q.step === currentStep),
    [questions, currentStep],
  );

  const TOTAL_BOT = stepQuestions.length + 3;

  /* ── Bot state ── */
  const [guideStep, setGuideStep] = useState<number|null>(null);
  const autoAdvancedRef = useRef<Set<number>>(new Set());

  /* Track viewport width so the spacer (which pushes content down while the
     bot is showing) matches the popup's actual mobile/desktop size. */
  const [viewportW, setViewportW] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  useEffect(() => {
    const onResize = () => setViewportW(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const spacerH = (viewportW < 768 ? POPUP_H_MOBILE : POPUP_H_DESKTOP) + GAP + 8;

  /* Renders an invisible spacer right after a bot-guide anchor. This pushes
     the next question/field down in normal document flow so the fixed-position
     bot popup (which floats below the anchor) never overlaps/hides its content. */
  const BotSpacer = ({ n }: { n: number }) => (
    <div style={{ height: guideStep === n ? spacerH : 0, transition: "height .2s ease" }} />
  );

  const qWrapRefs = useMemo(
    () => stepQuestions.map(() => React.createRef<HTMLDivElement>()),
    [stepQuestions.length],
  );
  const refOcc      = useRef<HTMLDivElement>(null);
  const refHeight   = useRef<HTMLDivElement>(null);
  const refContinue = useRef<HTMLDivElement>(null);

  useEffect(() => {
    injectKF();
    const seen = localStorage.getItem("step3Guide");
    if (!seen) { localStorage.setItem("step3Guide","1"); setTimeout(() => setGuideStep(1), 300); }
  }, []);

  useEffect(() => {
    if (guideStep === null) return;
    getBotRef(guideStep)?.current?.scrollIntoView({ behavior:"smooth", block:"center" });
  }, [guideStep]);

  const nextBot = useCallback(() => setGuideStep(p => p !== null && p < TOTAL_BOT ? p + 1 : null), [TOTAL_BOT]);
  const skipBot = useCallback(() => setGuideStep(null), []);

  const autoAdvanceBot = useCallback((targetStep: number) => {
    if (autoAdvancedRef.current.has(targetStep)) return;
    autoAdvancedRef.current.add(targetStep);
    setTimeout(() => {
      setGuideStep(prev => {
        if (prev === targetStep - 1 || prev === targetStep) return targetStep;
        return prev;
      });
    }, 550);
  }, []);

  const gw = (n: number): React.CSSProperties => {
    if (n === TOTAL_BOT) return { position: "relative" };
    return { position: "relative", zIndex: guideStep === n ? 9500 : 1 };
  };

  const getBotData = (n: number): StepData => {
    const qc = stepQuestions.length;
    if (n <= qc) {
      const q = stepQuestions[n-1]; const isMulti = q.allowMultiple;
      return {
        tag:    `STEP ${n} OF ${TOTAL_BOT} — ABOUT YOU`,
        plain:  isMulti ? `${q.question} — choose as many as you like!` : `${q.question} — select the option that fits you!`,
        html:   isMulti ? <><strong>{q.question}</strong> — choose as many as you like!</> : <><strong>{q.question}</strong> — select the option that fits you!</>,
        sideLg: "below",
      };
    }
    if (n === qc+1) return { tag:`STEP ${n} OF ${TOTAL_BOT} — OCCUPATION`, plain:"What is your occupation? Pick from popular options or search!", html:<><strong>What is your occupation?</strong> Pick from popular options or search!</>, sideLg:"below" };
    if (n === qc+2) return { tag:`STEP ${n} OF ${TOTAL_BOT} — HEIGHT`, plain:"Set your height by dragging the slider!", html:<>📏 Set your <strong>height</strong> by dragging the slider!</>, sideLg:"below" };
    return { tag:`STEP ${n} OF ${TOTAL_BOT} — ALL SET!`, plain:"All done! Tap Continue to move to the next step!", html:<>🚀 All done! <strong>Tap Continue</strong> to move to the next step!</>, sideLg:"below" };
  };

  const getBotRef = (n: number): React.RefObject<HTMLDivElement|null> => {
    const qc = stepQuestions.length;
    if (n <= qc)    return qWrapRefs[n-1];
    if (n === qc+1) return refOcc;
    if (n === qc+2) return refHeight;
    return refContinue;
  };

  const isAnswered = (q:any) => {
    if (!q) return false;
    if (Array.isArray(q.selected)) return q.selected.length > 0;
    return q.selected !== "" && q.selected !== null;
  };

  const filteredOccs = useMemo(() => {
    const t = occSearch.trim().toLowerCase(); if (!t) return [];
    return ALL_OCCUPATIONS.filter(o => o.toLowerCase().includes(t)).slice(0,18);
  }, [occSearch]);

  const heightInches = Number(inputs["height"]) || 64;
  const feet = Math.floor(heightInches/12), inches = heightInches % 12;
  const cm   = Math.round(heightInches * 2.54);
  const pct  = ((heightInches - 48) / (84 - 48)) * 100;

  const handleSubmit = (e: React.MouseEvent) => {
    e.preventDefault(); e.stopPropagation();
    if (validate3()) nextStep();
    else { setBtnHighlight(true); setTimeout(() => setBtnHighlight(false), 900); }
  };

  return (
    <>
      {guideStep !== null && guideStep >= 1 && guideStep <= TOTAL_BOT && (
        <BotPopup
          anchorRef={getBotRef(guideStep)} step={guideStep} total={TOTAL_BOT}
          data={getBotData(guideStep)} onSkip={skipBot}
          onNext={guideStep < TOTAL_BOT ? nextBot : skipBot}
          nextLabel={guideStep < TOTAL_BOT ? "Next →" : "Done ✓"}
        />
      )}

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-primary">
        <div className="container justify-content-center">
          <Link className="navbar-brand" to="/"><img src={logo} alt="" className="img-fluid"/></Link>
        </div>
      </nav>

      {/* Main */}
      <section className="ob3-section onboarding_main_wraper py-60">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-10 offset-xl-2 offset-lg-1">

              <div className="onboarding_step_top_wraper mb-4">
                <h2 className="mb-1" style={{ fontFamily:"'Inter',sans-serif", fontWeight:800, letterSpacing:"-.02em" }}>
                  Tell us about yourself
                </h2>
                <p style={{ color:"#94a3b8", fontSize:13, fontFamily:"'Inter',sans-serif", marginBottom:10 }}>
                  Question 3/6
                </p>
                <div className="ob3-prog-wrap">
                  <div className="ob3-prog-bar done"/>
                  <div className="ob3-prog-bar done"/>
                  <div className="ob3-prog-bar active"/>
                  <div className="ob3-prog-bar"/>
                  <div className="ob3-prog-bar"/>
                  <div className="ob3-prog-bar"/>
                </div>
              </div>

              <form className="onboarding_form" onSubmit={e => e.preventDefault()} onKeyDown={e => { if (e.key === "Enter") e.preventDefault(); }}>
                {stepQuestions.length > 0 ? (
                  <>
                    {stepQuestions.map((question: any, qIdx: number) => {
                      const isVisible   = qIdx === 0 || isAnswered(stepQuestions[qIdx-1]);
                      const isMulti     = question.allowMultiple;
                      const rawSelected = question.selected;
                      const selectedIds: number[] = Array.isArray(rawSelected)
                        ? (rawSelected as Array<number|string>).map(Number)
                        : (rawSelected !== null && rawSelected !== "" ? [Number(rawSelected)] : []);

                      if (isMulti) {
                        const pSearch = (persnSearch[question.id]||"").trim().toLowerCase();
                        const visibleOpts = pSearch
                          ? question.questions_options.filter((o:any) => o.option.toLowerCase().includes(pSearch))
                          : question.questions_options;
                        return (
                          <React.Fragment key={question.id}>
                            <div ref={qWrapRefs[qIdx]}
                              className={`form_group ${isVisible ? "slide-in" : "slide-out"}`}
                              style={gw(qIdx+1)}
                            >
                              <label className="form-label w-100">{question.question}</label>
                              <div className="ob3-multi-hint">
                                <span style={{fontSize:14}}>✦</span>
                                Choose as many as you like
                                {selectedIds.length > 0 && <span className="ob3-chip-count">{selectedIds.length} selected</span>}
                              </div>
                              <div className="ob3-search-wrap">
                                <SearchIcon/>
                                <input type="text" className="ob3-search-input" placeholder="Search personality traits…"
                                  value={persnSearch[question.id]||""}
                                  onChange={e => setPersnSearch(prev => ({...prev,[question.id]:e.target.value}))}
                                />
                              </div>
                              {visibleOpts.length > 0 ? (
                                <div style={{display:"flex",flexWrap:"wrap",marginTop:4}}>
                                  {visibleOpts.map((opt:any) => {
                                    const sel = selectedIds.includes(opt.id);
                                    return (
                                      <button key={opt.id} type="button"
                                        className={`ob3-chip${sel ? " selected" : ""}`}
                                        onClick={() => {
                                          selectOption(question.id, opt.id);
                                          if (!sel && selectedIds.length === 0) autoAdvanceBot(qIdx + 2);
                                        }}
                                        aria-pressed={sel}
                                      >
                                        {sel && <span className="ob3-chip-check">✓</span>}
                                        {opt.option}
                                      </button>
                                    );
                                  })}
                                </div>
                              ) : (
                                <p style={{fontSize:13,color:"#adb5bd",margin:"8px 0"}}>No traits found for "{pSearch}"</p>
                              )}
                              {errors[`question_${question.id}`] && <p className="text-danger text-sm mt-1">{errors[`question_${question.id}`]}</p>}
                            </div>
                            <BotSpacer n={qIdx+1} />
                          </React.Fragment>
                        );
                      }

                      // Single-select questions
                      const isSearchable = question.id === 9;
                      const searchTerm   = (optionSearchTerms[question.id]||"").trim().toLowerCase();
                      const filteredOpts = isSearchable
                        ? (searchTerm ? question.questions_options.filter((o:any) => o.option.toLowerCase().startsWith(searchTerm)) : [])
                        : question.questions_options;

                      return (
                        <React.Fragment key={question.id}>
                          <div ref={qWrapRefs[qIdx]}
                            className={`form_group ${isVisible ? "slide-in" : "slide-out"}`}
                            style={gw(qIdx+1)}
                          >
                            <label className="form-label w-100">{question.question}</label>
                            {isSearchable && (
                              <input type="text" className="ob3-search-input" style={{marginBottom:10}}
                                placeholder="Type first letter to search…"
                                value={optionSearchTerms[question.id]||""}
                                onChange={e => setOptionSearchTerm(question.id, e.target.value)}
                              />
                            )}
                            {/* ── Single-select uses ob3-pill (same unified style) ── */}
                            <div style={{display:"flex",flexWrap:"wrap",marginTop:4}}>
                              {filteredOpts.map((opt:any) => {
                                const sel = selectedIds.includes(opt.id);
                                return (
                                  <button key={opt.id} type="button"
                                    className={`ob3-pill${sel ? " selected" : ""}`}
                                    onClick={() => {
                                      selectOption(question.id, opt.id);
                                      if (!sel) autoAdvanceBot(qIdx + 2);
                                    }}
                                    aria-pressed={sel}
                                  >
                                    {sel && <span className="ob3-chip-check">✓</span>}
                                    {opt.option}
                                  </button>
                                );
                              })}
                            </div>
                            {errors[`question_${question.id}`] && <p className="text-danger text-sm">{errors[`question_${question.id}`]}</p>}
                          </div>
                          <BotSpacer n={qIdx+1} />
                        </React.Fragment>
                      );
                    })}

                    {/* ── Occupation ── */}
                    <div ref={refOcc}
                      className={`form_group ${isAnswered(stepQuestions[stepQuestions.length-1]) ? "slide-in" : "slide-out"}`}
                      style={gw(stepQuestions.length+1)}
                    >
                      <label className="form-label w-100">What is your occupation?</label>
                      {inputs["occupation"] && (
                        <div style={{marginBottom:10}}>
                          <div className="ob3-occ-selected">
                            ✓ {inputs["occupation"]}
                            <button type="button" className="ob3-occ-clear"
                              onClick={() => handleInputChange("occupation","")} title="Clear">✕</button>
                          </div>
                        </div>
                      )}
                      <div className="ob3-search-wrap">
                        <SearchIcon/>
                        <input type="text" className="ob3-search-input" placeholder="Search occupation… e.g. 'Doctor', 'Eng'"
                          value={occSearch}
                          onChange={e => setOccSearch(e.target.value)}
                        />
                      </div>
                      {occSearch.trim() ? (
                        <div className="ob3-pills-wrap">
                          {filteredOccs.length > 0 ? (
                            filteredOccs.map(occ => (
                              <button key={occ} type="button"
                                className={`ob3-pill${inputs["occupation"] === occ ? " selected" : ""}`}
                                onClick={() => {
                                  handleInputChange("occupation", occ);
                                  setOccSearch("");
                                  autoAdvanceBot(stepQuestions.length + 2);
                                }}>
                                {inputs["occupation"] === occ && <span className="ob3-chip-check">✓</span>}
                                {occ}
                              </button>
                            ))
                          ) : (
                            <div style={{width:"100%"}}>
                              <p style={{fontSize:12.5,color:"#adb5bd",marginBottom:4}}>No match found</p>
                              <button type="button" className="ob3-use-link"
                                onClick={() => {
                                  handleInputChange("occupation", occSearch.trim());
                                  setOccSearch("");
                                  autoAdvanceBot(stepQuestions.length + 2);
                                }}>
                                Use "{occSearch.trim()}" as my occupation →
                              </button>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div>
                          <div className="ob3-section-label">Popular</div>
                          <div className="ob3-pills-wrap">
                            {POPULAR_OCCUPATIONS.map(occ => (
                              <button key={occ} type="button"
                                className={`ob3-pill${inputs["occupation"] === occ ? " selected" : ""}`}
                                onClick={() => {
                                  handleInputChange("occupation", inputs["occupation"] === occ ? "" : occ);
                                  if (inputs["occupation"] !== occ) autoAdvanceBot(stepQuestions.length + 2);
                                }}>
                                {inputs["occupation"] === occ && <span className="ob3-chip-check">✓</span>}
                                {occ}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                      {errors["occupation"] && <p className="text-danger text-sm mt-1">{errors["occupation"]}</p>}
                    </div>
                    <BotSpacer n={stepQuestions.length+1} />

                    {/* ── Height ── */}
                    <div ref={refHeight}
                      className={`form_group ${inputs["occupation"] ? "slide-in" : "slide-out"}`}
                      style={gw(stepQuestions.length+2)}
                    >
                      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:4}}>
                        <label className="form-label mb-0">What is your height?</label>
                        <span className="ob3-ht-badge">{feet}′ {inches}″ · {cm} cm</span>
                      </div>
                      <div className="ob3-slider-track">
                        <div className="ob3-slider-fill" style={{width:`${pct}%`}}/>
                        <input type="range" className="ob3-range" min={48} max={84} step={1}
                          value={heightInches}
                          onChange={e => {
                            handleInputChange("height", e.target.value);
                            autoAdvanceBot(TOTAL_BOT);
                          }}
                        />
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between",marginTop:6}}>
                        <span style={{fontSize:"11px",color:"#adb5bd"}}>4′ 0″</span>
                        <span style={{fontSize:"11px",color:"#adb5bd"}}>7′ 0″</span>
                      </div>
                      {errors["height"] && <p className="text-danger text-sm mt-1">{errors["height"]}</p>}
                    </div>
                    <BotSpacer n={stepQuestions.length+2} />
                  </>
                ) : (
                  <p style={{textAlign:"center",padding:"40px 0",color:"#94a3b8",fontFamily:"'Inter',sans-serif"}}>Loading questions…</p>
                )}

                {/* ── Buttons ── */}
                <div className="d-flex justify-content-between mt-4">
                  <button type="button" className="ob3-btn-back" onClick={e => { e.preventDefault(); prevStep(); }}>
                    <i className="fa-solid fa-arrow-left" style={{fontSize:12}}/> Back
                  </button>
                  <div ref={refContinue}>
                    <button type="button" onClick={handleSubmit}
                      className={`ob3-btn-continue${btnHighlight ? " lit" : ""}`}>
                      Continue <i className="fa-solid fa-arrow-right" style={{fontSize:12}}/>
                    </button>
                  </div>
                </div>
                <BotSpacer n={TOTAL_BOT} />

              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step3;